export default function BagIcon() {
  return (
    <>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.4375 2.75C5.4375 1.61091 6.36091 0.6875 7.5 0.6875H10.5C11.6391 0.6875 12.5625 1.61091 12.5625 2.75V3.5C12.5625 3.81066 12.3107 4.0625 12 4.0625H6C5.68934 4.0625 5.4375 3.81066 5.4375 3.5V2.75ZM7.5 1.8125C6.98223 1.8125 6.5625 2.23223 6.5625 2.75V2.9375H11.4375V2.75C11.4375 2.23223 11.0178 1.8125 10.5 1.8125H7.5Z"
          fill="#5E718D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.9375 5C0.9375 3.86091 1.86091 2.9375 3 2.9375H15C16.1391 2.9375 17.0625 3.86091 17.0625 5V13.25C17.0625 14.3891 16.1391 15.3125 15 15.3125H12.75C12.4393 15.3125 12.1875 15.0607 12.1875 14.75C12.1875 14.4393 12.4393 14.1875 12.75 14.1875H15C15.5178 14.1875 15.9375 13.7678 15.9375 13.25V5C15.9375 4.48223 15.5178 4.0625 15 4.0625H3C2.48223 4.0625 2.0625 4.48223 2.0625 5V13.25C2.0625 13.7678 2.48223 14.1875 3 14.1875H9C9.31066 14.1875 9.5625 14.4393 9.5625 14.75C9.5625 15.0607 9.31066 15.3125 9 15.3125H3C1.86091 15.3125 0.9375 14.3891 0.9375 13.25V5Z"
          fill="#5E718D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.9375 5C0.9375 3.86091 1.86091 2.9375 3 2.9375H15C16.1391 2.9375 17.0625 3.86091 17.0625 5V7.25C17.0625 7.4984 16.8996 7.7174 16.6616 7.78878L9.16163 10.0388C9.0562 10.0704 8.9438 10.0704 8.83837 10.0388L1.33837 7.78878C1.10044 7.7174 0.9375 7.4984 0.9375 7.25V5ZM3 4.0625C2.48223 4.0625 2.0625 4.48223 2.0625 5V6.83148L9 8.91273L15.9375 6.83148V5C15.9375 4.48223 15.5178 4.0625 15 4.0625H3Z"
          fill="#5E718D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 7.4375C9.31066 7.4375 9.5625 7.68934 9.5625 8V11C9.5625 11.3107 9.31066 11.5625 9 11.5625C8.68934 11.5625 8.4375 11.3107 8.4375 11V8C8.4375 7.68934 8.68934 7.4375 9 7.4375Z"
          fill="#5E718D"
        />
      </svg>
    </>
  );
}
